import { render } from "./PaymentSummaryModal.vue?vue&type=template&id=60637266&scoped=true"
import script from "./PaymentSummaryModal.vue?vue&type=script&lang=js"
export * from "./PaymentSummaryModal.vue?vue&type=script&lang=js"

import "./PaymentSummaryModal.vue?vue&type=style&index=0&id=60637266&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60637266"]])

export default __exports__